import { Navigate } from "react-router-dom";
import {
  createDraftScheduleUrl,
  createPreConServicesDetailUrl,
  createPreConServicesUrl,
  createProjectDashboardUrl,
  createProjectScheduleUrl,
  createSpecsAndSelectionsDetailUrl,
  createSpecsAndSelectionsUrl,
} from "src/RouteUrls";
import { useRouteParams } from "src/hooks/useRouteParams";
import { RedirectToActiveStage } from "src/routes/projects/components/RedirectToActiveStage";
import { ProjectParams } from "src/routes/routesDef";

/** Index `/projects/:projectId` → dashboard. */
export function RedirectToProjectDashboard() {
  const { projectId } = useRouteParams<ProjectParams>();
  return <Navigate to={createProjectDashboardUrl(projectId)} replace />;
}

/** `/projects/:projectId/schedule` → active stage schedule URL. */
export function RedirectToProjectScheduleStage() {
  const { projectId } = useRouteParams<ProjectParams>();
  return (
    <RedirectToActiveStage
      showPlanning
      projectId={projectId}
      createUrl={(stage) => createProjectScheduleUrl(projectId, stage)}
    />
  );
}

/** `/projects/:projectId/dynamicSchedule` → draft schedule. */
export function RedirectToDraftSchedule() {
  const { projectId } = useRouteParams<ProjectParams>();
  return <Navigate to={createDraftScheduleUrl(projectId)} replace />;
}

/** Deprecated selections base → specs and selections. */
export function RedirectSelectionsBaseToSpecs() {
  const { projectId } = useRouteParams<ProjectParams>();
  return <Navigate to={createSpecsAndSelectionsUrl(projectId)} replace />;
}

/** Deprecated selections pre-con list → pre-con services. */
export function RedirectSelectionsPreConToServices() {
  const { projectId } = useRouteParams<ProjectParams>();
  return <Navigate to={createPreConServicesUrl(projectId)} replace />;
}

/** Deprecated selections construction list → specs and selections. */
export function RedirectSelectionsConstructionToSpecs() {
  const { projectId } = useRouteParams<ProjectParams>();
  return <Navigate to={createSpecsAndSelectionsUrl(projectId)} replace />;
}

/** Deprecated `/selections/.../:projectItemId` → new detail URLs with real ids. */
export function RedirectToSelectionDetail(props: { stage: "preCon" | "construction" }) {
  const { stage } = props;
  const { projectId, projectItemId } = useRouteParams<ProjectParams & { projectItemId: string }>();
  const to =
    stage === "preCon"
      ? createPreConServicesDetailUrl(projectId, projectItemId)
      : createSpecsAndSelectionsDetailUrl(projectId, projectItemId);
  return <Navigate to={to} replace />;
}

export function RedirectToSelectionDetailPreCon() {
  return <RedirectToSelectionDetail stage="preCon" />;
}

export function RedirectToSelectionDetailConstruction() {
  return <RedirectToSelectionDetail stage="construction" />;
}

export function RedirectToBidContractOverview() {
  return <Navigate to="overview" replace relative="path" />;
}
